import React, { ReactNode } from 'react';
import { Button } from '@mui/material';
import FieldRow from 'components/FormElements/FieldRow';
import Heading from 'components/Heading';
import { Column, Margin } from 'components/Layout';
import PageContent from 'components/PageContent';

export type UploadStatusSummaryRow = {
  label: string;
  value: ReactNode;
};

type Props = {
  title: string;
  summaryRows: Array<UploadStatusSummaryRow>;
  failedRowsContent?: ReactNode;
  onRestart: () => void;
  restartButtonText?: string;
};

const UploadStatus: React.FC<Props> = ({
  title,
  summaryRows,
  failedRowsContent,
  onRestart,
  restartButtonText = 'Create another upload',
}) => (
  <PageContent>
    <Heading variant="h2">{title}</Heading>
    <Margin bottom="lg">
      <Column fullWidth spacing="xs">
        {summaryRows.map((row) => (
          <FieldRow key={row.label} title={row.label}>
            {row.value}
          </FieldRow>
        ))}
      </Column>
    </Margin>

    {failedRowsContent}

    <Margin top="lg" bottom="lg">
      <Button variant="outlined" onClick={onRestart}>
        {restartButtonText}
      </Button>
    </Margin>
  </PageContent>
);

export default UploadStatus;
